import { render, staticRenderFns } from "./AiQuality.vue?vue&type=template&id=f60436bc"
import script from "./AiQuality.vue?vue&type=script&lang=js"
export * from "./AiQuality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports